/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestFullResponse } from '../../models/harvest-full-response';
import { HarvestUpdateRequest } from '../../models/harvest-update-request';

export interface UpdateHarvest$Params {
  harvestId: number;
      body: HarvestUpdateRequest
}

export function updateHarvest(http: HttpClient, rootUrl: string, params: UpdateHarvest$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestFullResponse>> {
  const rb = new RequestBuilder(rootUrl, updateHarvest.PATH, 'put');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestFullResponse>;
    })
  );
}

updateHarvest.PATH = '/api/harvests/{harvestId}';
